import { safeClone, ViewStream } from "spyne";
import { SidebarRenderTraits } from "traits/sidebar-render-traits";
import { SidebarTraits } from "traits/sidebar-traits";

export class SidebarMenuView extends ViewStream {
  constructor(props = {}) {
    props.tagName = "nav";
    props.traits = SidebarRenderTraits;
    props.class = `sidebar-menu menu-${props.menuType}`;
    props.data = safeClone(props.data);

    const dataHashTable = {
      docs: props.data.docsContent,
      tools: props.data.toolsPageContent,
      compare: props.data.comparePageContent,
      reference: props.data.referencePageContent,
      configure: props.data.configuratorPageContent,
    };

    const isDocsPage = false; // removed docs option for views, behavior, logic containers props.pageId === 'docs';

    if (isDocsPage === true) {
      props["renderData"] =
        SidebarRenderTraits.sidebarRender$ConformDataForDocsContainers(
          dataHashTable[props.pageId],
        );
      props.data.sidebarData = props.renderData.sidebarData;
    } else {
      props.data.sidebarData = dataHashTable[props.pageId];
    }

    const mapSidebarData = (o) => {
      const { isSidebarSection, sidebarIndent } = o;

      o["sidebarSection"] = isSidebarSection ? "sidebar-section" : "";
      o["sidebarIndent"] =
        sidebarIndent !== undefined ? `sidebar-indent-${sidebarIndent}` : "";
      o.menuData.section ??= o.menuData.container;
      return o;
    };

    if (props.pageId === "reference") {
      safeClone(props.data.sidebarData.map(mapSidebarData));
    }

    //console.log("PROPS DATA SIDEBAR MENU ", props);
    // props.data.sidebarData = props.pageId==='docs' ? props.data.docsContent : props.data.comparePageContent;

    props.template = require("./templates/sidebar-menu-quick-start.tmpl.html");
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    return [
      ["CHANNEL_SIDEBAR_REVEAL_PANEL", "onRemoveSidebarMenu"],
      ["CHANNEL_SIDEBAR_HIDE_PANEL", "onRemoveSidebarMenu"],
      ["CHANNEL_SIDEBAR_NAVIGATION_EVENT", "onNavEvent"],
    ];
  }

  onRouteCardEvent(e) {
   //console.log("ROUTE CARD EVENT ", e);
  }

  onNavEvent(e) {
    const { payload, srcElement } = e;
    const { typeId, exampleId, routeData } = payload;
    const {container} = routeData;
    const itemId = payload?.itemId ?? payload?.routeData?.itemId;

   //console.log("NAV EVENT ",{itemId, typeId, payload});
    //const itemId = payload?.itemId ?? SidebarTraits.sidebar$GetItemIdByRouteData(e.payload.routeData);

    const isMethodLink = payload?.pathsChanged?.[0] === "classMethod";

    if (isMethodLink) {
      return;
    }


    if (itemId === 'docs-examples' && String(container).length>1){
      this.setMenuEl(this.props.el$(`[data-container='${container}']`).el);
      return;
    }


    if (itemId !== false || srcElement?.el !== undefined) {
      const el =
        srcElement?.el || this.props.el$(`[data-item-id='${itemId}']`).el;

     //console.log("nav event ", { typeId, itemId, payload, el, e });
      //this.setMenuSelected(exampleId, typeId);
      this.setMenuEl(el);
    }
  }

  setMenuEl(el) {
    this.props.el$("a").setActiveItem("selected", el);
  }

  setMenuSelected(
    itemId = this.props.itemId,
    typeId = this.props.typeId,
    pageId = this.props.pageId,
  ) {

    const isDocs = this.props.pageId === 'docs';
    //const classSel = `a.item-${pageId}-${typeId}-${exampleId}`;
    const sel = isDocs ? itemId : `[data-item-id='${itemId}']`;
    this.props.el$("a").setActiveItem("selected", sel);

    if (this.props.pageId === "docs" && this?.props?.initPayload?.isDeepLink === true && this.props?.initPayload?.routeData?.stage === 'examples'){
      const { container } = this.props?.initPayload?.routeData;

      if (container !== undefined && String(container).length>2){
        const data = this.props.el$(`${sel}`).el.dataset;
        const payload = {...data};

       const delay = ()=> this.sendInfoToChannel("CHANNEL_ROUTE", payload);

       window.setTimeout(delay, 100);
         ////console.log("RUN DATA ",data);
      }


      //this.sendInfoToChannel("CHANNEL_ROUTE", data);

    }

   //console.log(" SET MENU SELECTED ",this.props.pageId,{typeId, itemId},  this.props.el$(sel).exists)
  }

  onRemoveSidebarMenu() {
    this.disposeViewStream();
  }

  broadcastEvents() {
    // return nexted array(s)
    return [["nav a", "click"]];
  }

  onRendered() {
    this.addChannel("CHANNEL_SIDEBAR", true);
    this.setMenuSelected();
    if (this.props.pageId === "docs") {
      // this.sidebarRender$ContainerSections();
    }
    // window.setTimeout(this.setMenuSelected.bind(this), 1000);
  }
}
